import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { IdentityUserAri } from '@atlassian/ari/identity/user';

import type { NavigationSettingScope } from './types.tsx';

type AccountId = string;
type ActivationId = string;
type CloudId = string;

export const createNavigationSettingScope = (
	menuName: string,
	parentType?: string,
	parentId?: string,
): string => {
	if ((parentType === undefined) !== (parentId === undefined)) {
		throw new Error(
			'Invalid Navigation Setting Scope parentType and parentId must be defined together',
		);
	}
	if (parentType !== undefined && parentId !== undefined) {
		return `${parentType}/${parentId}/${menuName}`;
	}
	return menuName;
};

export const parseNavigationSettingsScope = (scope: string): NavigationSettingScope => {
	const [parentTypeOrMenuName, parentId, menuName] = scope.split('/');
	if (parentTypeOrMenuName && !parentId && !menuName) {
		return { menuName: parentTypeOrMenuName };
	}
	if (parentTypeOrMenuName && parentId && menuName) {
		return { parentType: parentTypeOrMenuName, parentId, menuName };
	}
	throw new Error('Invalid Navigation Setting Scope format');
};

export const createSidebarSettingsAri = (
	cloudId: CloudId,
	activationId: ActivationId,
	menuName: string,
	parentType?: string,
	parentId?: string,
): string => {
	return JiraNavigationSettingsAri.create({
		siteId: cloudId,
		activationId,
		navigationSettingScope: createNavigationSettingScope(menuName, parentType, parentId),
	}).toString();
};

export const parseSidebarSettingsAri = (ariLikeString: string) => {
	const ari = JiraNavigationSettingsAri.parse(ariLikeString);
	return parseNavigationSettingsScope(ari.navigationSettingScope);
};

export const createIdentityUserAri = (userId: AccountId): string => {
	return IdentityUserAri.create({ userId }).toString();
};
